import * as types from "../types";
const state = {
  navigationsDrawer: false,
  drawer: false,
  drawerItemName: ""
};
const getters = {
  [types.GET_DRAWER]: state => {
    return state.drawer;
  },
  [types.GET_NAVIGATIONS_DRAWER]: state => {
    return state.navigationsDrawer;
  },
  [types.GET_DRAWER_ITEM_NAME]: state => {
    return state.drawerItemName;
  }
};

const mutations = {
  [types.MUTATE_DRAWER]: (state, drawerState) => {
    state.drawer = drawerState;
  },
  [types.MUTATE_NAVIGATIONS_DRAWER]: (state, drawerState) => {
    state.navigationsDrawer = drawerState;
  },
  [types.MUTATE_DRAWER_ITEM_NAME]: (state, payload) => {
    state.drawerItemName = payload;
  }
};

const actions = {
  [types.ACTION_DRAWER]: ({ commit }, payload) => {
    commit(types.MUTATE_DRAWER, payload);
  },
  [types.ACTION_NAVIGATIONS_DRAWER]: ({ commit }, payload) => {
    commit(types.MUTATE_NAVIGATIONS_DRAWER, payload);
  },
  [types.ACTION_DRAWER_ITEM_NAME]: ({ commit }, payload) => {
    commit(types.MUTATE_DRAWER_ITEM_NAME, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
